export default __webpack_public_path__ + "static/media/jodhpur1.29b820a9.jpg";